// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1V_Jy","list":"PatternAutocomplete_list__pkKJ5"};